// Marca do Nexus: um "N" desenhado como rede de nós conectados; o nó laranja é o próximo passo.
import { useId } from 'react';
import { clsx } from './ui.tsx';

export function LogoMark({ size = 32, className }: { size?: number; className?: string }) {
  const id = useId();
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" className={className} role="img" aria-label="Nexus">
      <defs>
        <linearGradient id={`${id}-bg`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#1c3866" />
          <stop offset="1" stopColor="#071427" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="15" fill={`url(#${id}-bg)`} />
      <rect x="1" y="1" width="62" height="62" rx="14" fill="none" stroke="#fff" strokeOpacity=".12" strokeWidth="2" />
      <path d="M20 44V20l24 24V22" fill="none" stroke="#fff" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="20" cy="44" r="5.5" fill="#fff" />
      <circle cx="20" cy="20" r="5.5" fill="#fff" />
      <circle cx="44" cy="44" r="5.5" fill="#fff" />
      <circle cx="44" cy="20" r="8" fill="#f97316" stroke="#132a4f" strokeWidth="3" />
    </svg>
  );
}

/** Marca + nome. tone="light" para fundos escuros, "dark" para fundos claros. */
export function Logo({ size = 32, tone = 'light', subtitle = true, className }: { size?: number; tone?: 'light' | 'dark'; subtitle?: boolean; className?: string }) {
  const big = size >= 44;
  return (
    <span className={clsx('inline-flex items-center gap-2.5', className)}>
      <LogoMark size={size} className="shrink-0 drop-shadow-sm" />
      <span className="leading-none">
        <span className={clsx('block font-semibold tracking-wide', big ? 'text-2xl' : 'text-[15px]', tone === 'light' ? 'text-white' : 'text-navy-900')}>
          NE<span className={tone === 'light' ? 'text-accent-500' : 'text-accent-600'}>X</span>US
        </span>
        {subtitle && (
          <span className={clsx('mt-1 block font-medium tracking-wide uppercase', big ? 'text-[11px]' : 'text-[10px]', tone === 'light' ? 'text-navy-300' : 'text-slate-500')}>
            Gestão de projetos
          </span>
        )}
      </span>
    </span>
  );
}
